export default __webpack_public_path__ + "static/media/six.1f84d973.jpeg";